module.exports = __webpack_public_path__ + "img/info2.587be4ea.png";